import Vue from 'vue';
import App from '../obstacles/app.vue';

document.addEventListener('DOMContentLoaded', function(){
  new Vue({
    el: '#obstacles-component',
    component: App,
    render: function(h){
      return h(App);
    }
  });
});
